import React, { useEffect } from 'react';
import { BrowserRouter as Router, Routes, Route, useLocation } from 'react-router-dom';
import { HomePage } from './pages/HomePage';
import { PrivacyPage } from './pages/PrivacyPage';
import { TermsPage } from './pages/TermsPage';
import { ContactPage } from './pages/ContactPage';
import { DocsHubPage } from './pages/DocsHubPage';
import { DocsCommerce7Page } from './pages/DocsCommerce7Page';
import { DocsShopifyPage } from './pages/DocsShopifyPage';
import { DocsAusPostCredentialsPage } from './pages/DocsAusPostCredentialsPage';
function ScrollToTop() {
  const {
    pathname
  } = useLocation();
  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);
  return null;
}
export function App() {
  return <Router data-id="element-0">
      <ScrollToTop data-id="element-1" />
      <Routes data-id="element-2">
        <Route path="/" element={<HomePage data-id="element-4" />} data-id="element-3" />
        <Route path="/privacy" element={<PrivacyPage data-id="element-6" />} data-id="element-5" />
        <Route path="/terms" element={<TermsPage data-id="element-8" />} data-id="element-7" />
        <Route path="/contact" element={<ContactPage data-id="element-10" />} data-id="element-9" />
        <Route path="/docs" element={<DocsHubPage data-id="element-12" />} data-id="element-11" />
        <Route path="/docs/shopify" element={<DocsShopifyPage data-id="element-14" />} data-id="element-13" />
        <Route path="/docs/commerce7" element={<DocsCommerce7Page data-id="element-16" />} data-id="element-15" />
        <Route path="/docs/auspost-credentials" element={<DocsAusPostCredentialsPage data-id="element-18" />} data-id="element-17" />
      </Routes>
    </Router>;
}